import React, { FC } from 'react';
import styled from 'styled-components';
import { BaseCell } from 'components/organisms/timesheets/common/timesheet-table';
import { SingleLineEllipsis } from 'components/styles';

const Cell = styled(BaseCell)`
  ${SingleLineEllipsis};
`;

export const WithEllipsis: FC<{ content: string }> = ({ content }) => (
  <Cell title={content}>{content}</Cell>
);
